import { api } from "~/utils/api";
import { useUser } from "~/modules/user/hooks/useUser";
import {
    FREE_PLAN_CHART_LIMIT,
    countSavedCharts,
} from "~/modules/charts/lib/freePlanChartLimit";

// // // //

/**
 * useCanSaveChart
 * Whether the current user may save (create or clone) another chart. Paid-plan
 * users and superadmins are unlimited; FREE-plan users can save up to
 * `FREE_PLAN_CHART_LIMIT` charts. The chart list is only fetched for limited
 * users, and shares its cache with the charts list page.
 */
export function useCanSaveChart(): {
    canSaveChart: boolean;
    isLimited: boolean;
    savedCount: number;
    loading: boolean;
} {
    const { user, isPaidPlan, isAdmin, loading: userLoading } = useUser();
    const isLimited = !userLoading && !isPaidPlan && !isAdmin;

    const chartsReq = api.charts.list.useQuery(
        { organizationID: user.organization.id },
        { enabled: isLimited },
    );

    const savedCount = countSavedCharts(chartsReq.data ?? [], user);

    return {
        canSaveChart: !isLimited || savedCount < FREE_PLAN_CHART_LIMIT,
        isLimited,
        savedCount,
        loading: userLoading || chartsReq.isInitialLoading,
    };
}
